module.exports = __webpack_public_path__ + "img/moon.0a423811.png";